import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { NfcSelectProductPageRoutingModule } from './nfc-select-product-routing.module';

import { NfcSelectProductPage } from './nfc-select-product.page';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IonicModule,
    NfcSelectProductPageRoutingModule
  ],
  declarations: [NfcSelectProductPage]
})
export class NfcSelectProductPageModule { }
